export const RETURN_ASSIGN_BOOK_REQUEST = 'RETURN_ASSIGN_BOOK_REQUEST'
export const RETURN_ASSIGN_BOOK_SUCCESS = 'RETURN_ASSIGN_BOOK_SUCCESS'
export const RETURN_ASSIGN_BOOK_FALIURE = 'RETURN_ASSIGN_BOOK_FALIURE'
